import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule,
} from "vuex-module-decorators";
import store from "@/store/index";
import ApiCart from "@/api/ApiCart";
import Swal from "sweetalert2";

import {
  MultimediaCartListResponse,
  MultimediaCartItemListResponse,
  MultimediaCartItemResponse,
} from "@API/src/component/memoruHome/cart/types";
import { MemoruUnitPriceResponse } from "@API/src/component/operation/memoru/types"
import {
  FetchCartListRequest,
  PutCartListRequestItem,
  PostCartItemRequest,
  DeleteCartItemRequest,
  FetchMultimediaPriceRequest,
  CheckoutCartRequest,
  SecureTranRequest,
} from "@/model/request/cart";

export interface CartState {
  carts: MultimediaCartItemListResponse | null;
  prices: MemoruUnitPriceResponse | null;
}

@Module({ dynamic: true, store, name: "cart", namespaced: true })
class CartModule extends VuexModule implements CartState {
  public carts: MultimediaCartItemListResponse | null = null;
  public prices: MemoruUnitPriceResponse | null = null

  @Action({ rawError: true })
  public async fetchCartList(request: FetchCartListRequest) {
    const response: MultimediaCartItemListResponse = await ApiCart.fetchCartList(
      request
    );
    this.setCarts(response);
    return response;
  }

  @Mutation
  public setCarts(carts: MultimediaCartItemListResponse) {
    this.carts = carts;
  }

  @Action({ rawError: true })
  public async putCartList(request: MultimediaCartItemListResponse) {
    const response: MultimediaCartItemListResponse = await ApiCart.putCartList(
      request
    );
    this.setCarts(response);
    return response;
  }

  @Action({ rawError: true })
  public async postCartItem(request: PostCartItemRequest) {
    const allFileSize = this.carts?.reduce((sum, cart) => sum + cart.fileSize, 0)
    if (allFileSize !== undefined) {
    const allFileSizeInGB = allFileSize / Math.pow(2, 30);
    console.log(`カート内の合計ファイルサイズ: ${allFileSizeInGB.toFixed(4)} GB`)
    }
    // console.log('allFileSize', allFileSize)
    // 一度に注文できるファイルサイズ合計値は1.8GB以下
    if (allFileSize !== undefined && allFileSize < 1.8 * Math.pow(2, 30)) {
      const response: MultimediaCartItemResponse = await ApiCart.postCartItem(
        request
      );
      this.addCarts(response)
      return response;
    } else {
      //Swal.fire(undefined, `1度に注文できるファイルは1.8GBまでです。`, "warning");
      Swal.fire(undefined, `カートがいっぱいになりました。<br>(1回の最大購入可能データ：1.8G） <br>これ以上カートに追加ができないため、<br>ご購入手続きにお進みください。`, "warning");
    }
  }

  @Mutation
  public addCarts(cart: MultimediaCartItemResponse) {
    if (this.carts) {
      this.carts = [...this.carts, cart];
    }
  }

  @Action({ rawError: true })
  public async deleteCartItem(request: DeleteCartItemRequest) {
    this.removeCarts(request.multimediaId)
    const response = await ApiCart.deleteCartItem(request);
    return response;
  }

  @Mutation
  public removeCarts(multimediaId: number) {
    if (this.carts) {
      this.carts = this.carts.filter(c => c.multimediaId !== multimediaId)
    }
  }

  @Action({ rawError: true })
  public async fetchMultimediaPrice(request: FetchMultimediaPriceRequest) {
    const response: MemoruUnitPriceResponse = await ApiCart.fetchMultimediaPrice(
      request
    );
    this.setPrices(response);
    return response;
  }

  @Mutation
  public setPrices(prices: MemoruUnitPriceResponse) {
    this.prices = prices;
  }

  @Action({ rawError: true })
  public async checkoutCart(request: CheckoutCartRequest) {
    const response = await ApiCart.checkoutCart(request);
    this.clearCarts();
    return response;
  }

  @Action({ rawError: true })
  public async checkoutCartSecureTran(request: SecureTranRequest) {
    const response = await ApiCart.checkoutCartSecureTran(request);
    this.clearCarts();
    return response;
  }

  @Mutation
  public clearCarts() {
    this.carts = null;
  }
}

export const cartModule = getModule(CartModule);
